var React = require('react');

function InformationCircleOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"m 10.802401,8.4072041 h 2.395198 V 6.0120069 H 10.802401 M 12,21.580789 C 6.7185901,21.580789 2.419211,17.28141 2.419211,12 2.419211,6.7185901 6.7185901,2.419211 12,2.419211 c 5.28141,0 9.580789,4.2993791 9.580789,9.580789 0,5.28141 -4.299379,9.580789 -9.580789,9.580789 z M 12,0.02401372 A 11.975986,11.975986 0 1 0 12,23.975986 11.975986,11.975986 0 0 0 12,0.02401372 Z M 10.802401,17.987993 h 2.395198 v -7.185592 h -2.395198 z","style":{"strokeWidth":"1.1976"}}));
}

InformationCircleOutline.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = InformationCircleOutline;

InformationCircleOutline.default = InformationCircleOutline;
